export const ERROR_TEXT = 'error'
export const BLANK_TEXT = ' '
